import type { Nullable } from '@silverhand/essentials';
import type { Ref } from 'react';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';

import PasswordHideIcon from '@/shared/assets/icons/password-hide-icon.svg?react';
import PasswordShowIcon from '@/shared/assets/icons/password-show-icon.svg?react';
import IconButton from '@/shared/components/IconButton';

import type { Props as InputFieldProps } from '../InputField';
import InputField from '../InputField';

import styles from './spark.module.scss';

type Props = Omit<InputFieldProps, 'type' | 'suffix' | 'isSuffixFocusVisible'>;

const PasswordInputField = (props: Props, forwardRef: Ref<Nullable<HTMLInputElement>>) => {
  const [showPassword, setShowPassword] = useState(false);
  const innerRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(forwardRef, () => innerRef.current);

  return (
    <div className={styles.container}>
      <label htmlFor={props.name} className={styles.label}>
        {props.label}
      </label>
      <InputField
        isSuffixFocusVisible
        type={showPassword ? 'text' : 'password'}
        suffix={
          <IconButton
            onMouseDown={(event) => {
              event.preventDefault();
              setShowPassword((previous) => !previous);
            }}
          >
            {showPassword ? <PasswordShowIcon /> : <PasswordHideIcon />}
          </IconButton>
        }
        {...props}
        ref={innerRef}
      />
    </div>
  );
};

export default forwardRef(PasswordInputField);
